import moment from "moment";
import "moment/locale/cs";

import ReactGA from "react-ga4";
import { RouterProvider } from "easy-page-router/react";

import Layout from "./Layout";
import Router from "./Router";
import { UserProvider } from "./User";

moment.locale("cs");

if (process.env.NODE_ENV !== "development") {
    ReactGA.initialize("G-2MLKWL0SVZ");
}

export default function App() {
    return (
        <RouterProvider onPageChange={href => {
            if (process.env.NODE_ENV !== "development") {
                const url = new URL(href);
                ReactGA.send({ hitType: "pageview", page: url.pathname + url.search });
            }
        }}>
            <UserProvider>
                <Layout>
                    <Router />
                </Layout>
            </UserProvider>
        </RouterProvider>
    );
}
